import React from "react";

import { IconMainMenuMonitors } from "~/components/icon";
import { Permission } from "~/models/dto";

import { usePermissions } from "../../common/use-permissions";
import { useNavigateToLink } from "../../components/react/link";
import { MONITORS_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemMonitors: React.FC = () => {
	const permissions = usePermissions();
	const link = useNavigateToLink(MONITORS_PATH, {
		params: {},
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (!permissions?.hasSystemPermission(Permission.GetMonitors)) {
		return null;
	}

	return (
		<MainMenuItemLayout
			className="monitorsMenu"
			icon={<IconMainMenuMonitors height={18} width={18} />}
			label="Monitors"
			to={link}
		/>
	);
};
